import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskSafetyInspectionIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            d='M3.19922 5.26004V14.28C3.19922 17.34 7.94922 19.83 11.5792 22.26C11.7292 22.35 11.8492 22.44 11.9992 22.56C12.1492 22.47 12.2692 22.38 12.4192 22.26C16.0492 19.83 20.7992 17.34 20.7992 14.28V5.26004L11.9992 1.29004L3.19922 5.26004ZM17.7292 8.52004L12.3292 13.95L11.0092 15.27L7.16922 11.43L8.48922 10.11L11.0092 12.63L16.4092 7.20004L17.7292 8.52004Z'
        />
    ),
})

TaskSafetyInspectionIcon.displayName = 'TaskSafetyInspectionIcon'
